const MessageCard = (props) => {
    return (
        <div className="card-message">
            <p>{props.message}</p>
        </div>
    )
};

export default MessageCard;